"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _styles = require("@ori-ui/mui-bundle/material/styles");
var _constants = require("../constants");
var _shadows = require("../shadows");
const styleOverrides = {
  rail: {
    height: 4,
    borderRadius: 2
  },
  track: {
    height: 4,
    borderRadius: 2
  },
  mark: {
    height: 4
  },
  thumb: {
    width: 28,
    height: 28,
    backgroundColor: _constants.colors.commonColors.white,
    boxShadow: _shadows.SHADOW_LEVEL1,
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: _shadows.SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: _shadows.SHADOW_LEVEL2
    },
    [`&.${_material.sliderClasses.disabled}`]: {
      width: 28,
      height: 28,
      backgroundColor: 'currentColor',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }
  },
  thumbColorPrimary: {
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: _shadows.SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: `${_shadows.SHADOW_LEVEL2}, 0px 0px 0px 8px ${(0, _styles.alpha)(_constants.colors.primary.main, 0.17)}`
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: _shadows.SHADOW_LEVEL3
    }
  },
  thumbColorSecondary: {
    [`&:hover, &.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: _shadows.SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    [`&.${_material.sliderClasses.focusVisible}`]: {
      boxShadow: `${_shadows.SHADOW_LEVEL2}, 0px 0px 0px 8px ${(0, _styles.alpha)(_constants.colors.secondary.main, 0.17)}`
    },
    [`&.${_material.sliderClasses.active}`]: {
      boxShadow: _shadows.SHADOW_LEVEL3
    }
  }
};
const defaultProps = {
  color: 'primary'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiSlider.js.map